import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Tag, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

const { Text } = Typography
const SingleViewClient = () => {
    let { clientId } = useParams()
    const navigate = useNavigate() 
    const [loading, setLoading] = useState(true)
    const [ clientDetails, setClientDetails] = useState(null);
    const ClientDetailView = async () => {
        setLoading(true)
        const result = await apiCalls?.ClientPostApi?.ClientDetailView(clientId);
        if (result) {
            setClientDetails(result);
        }
        setLoading(false)
    };

    useEffect(() => {
        ClientDetailView();
    }, [clientId]);

    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Full Name</Text>
                {
                    clientDetails ? 
                    <Text>
                        {clientDetails?.personalData.firstName?.charAt(0).toUpperCase() + clientDetails?.personalData?.firstName?.slice(1)}{' '}
                        {clientDetails?.personalData?.lastName?.charAt(0).toUpperCase() + clientDetails?.personalData?.lastName?.slice(1)}
                    </Text>
                    :
                    null
                }
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Email</Text>
                <Text>{clientDetails?.personalData?.email}</Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Contact Number</Text>
                <Text>{clientDetails?.personalData?.phoneNo}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Age</Text>
                <Text>{clientDetails?.personalData?.age}</Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Worker Experience</Text>
                <Text>{clientDetails?.projectDetails?.exp}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Need Services</Text>
                <Flex gap={5} wrap>
                    {
                        clientDetails?.services?.map((data)=>
                            <Tag className='brand-text border-brand'>
                                {data?.name}
                            </Tag>
                        )
                    }
                </Flex>
            </Space>,
        },
        {
            key: '4',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Registeration Date</Text>
                <Text>{clientDetails?.personalData?.date}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Project Details</Text>
                <Text>
                    {clientDetails?.projectDetails?.details}
                </Text>
            </Space>,
        },
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                        title: <Text className='cursor text-gray' onClick={()=>navigate('/clients')}>Client</Text>,
                    },
                    {
                        title: 
                        <Text className='fw-500'>
                            {
                                clientDetails ?
                                <>
                                    {clientDetails?.personalData?.firstName?.charAt(0).toUpperCase() + clientDetails?.personalData?.firstName?.slice(1)}{' '}
                                    {clientDetails?.personalData?.lastName?.charAt(0).toUpperCase() + clientDetails?.personalData?.lastName?.slice(1)}
                                </>
                                :null
                            }
                        </Text>
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={()=>navigate('/clients')}>
                                <ArrowLeftOutlined />
                            </Button>
                            {
                                clientDetails ? 
                                <>
                                    <Text className='fw-500'>
                                        {clientDetails?.personalData?.firstName?.charAt(0).toUpperCase() + clientDetails?.personalData?.firstName?.slice(1)}{' '}
                                        {clientDetails?.personalData?.lastName?.charAt(0).toUpperCase() + clientDetails?.personalData?.lastName?.slice(1)}
                                    </Text>
                                    {
                                        clientDetails?.personalData?.status === 1 ? (
                                            <Text className='badge-cs active'>Active</Text>
                                        ) : (
                                            <Text className='badge-cs inactive'>Inactive</Text>
                                        )
                                    }
                                </>
                                :
                                null
                            }
                        </Space>
                    </Col>  
                    <Col span={24}>
                        <Table 
                            size='large'
                            columns={columns} 
                            dataSource={data} 
                            scroll={{x: 1000}}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                            loading={
                                {
                                    ...TableLoader,
                                    spinning: loading
                                }
                            }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { SingleViewClient }
